var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5561 18.0508C26.558 17.8721 26.6312 17.7013 26.7596 17.5756C26.8881 17.4499 27.0614 17.3794 27.2421 17.3794H41.7082C41.8887 17.3793 42.0619 17.4498 42.1899 17.5756C42.318 17.7014 42.3905 17.8723 42.3916 18.0508V21.7413L47.4128 23.0775C47.7489 23.1641 47.9442 23.5343 47.8466 23.8951L44.8259 35.0484L44.8252 38.3903C44.8252 38.5703 44.7529 38.743 44.6243 38.8703C44.4956 38.9975 44.3211 39.0691 44.1392 39.0691H24.8082C24.6262 39.0691 24.4517 38.9975 24.3231 38.8703C24.1944 38.743 24.1221 38.5703 24.1221 38.3903V32.5579L21.1229 24.4062C20.9941 24.0553 21.1561 23.6721 21.4828 23.5547L26.5561 21.7278V18.0508ZM36.97 20.2987L41.4538 21.4918V18.3051H27.4939V21.3901L35.6217 18.4633C35.9488 18.3458 36.3214 18.5363 36.4507 18.8872L36.97 20.2987ZM44.6275 23.4512C44.4988 23.3239 44.3243 23.2524 44.1424 23.2524H38.0569L37.3611 21.3615L46.8763 23.8935L44.8267 31.4612L44.8284 23.9311C44.8284 23.7511 44.7561 23.5784 44.6275 23.4512ZM22.0895 24.3216L24.1221 29.8462V23.9311C24.1221 23.7926 24.1649 23.6585 24.2432 23.546L22.0895 24.3216ZM35.6551 19.4366L37.0592 23.2524H25.0587L35.6551 19.4366ZM41.2525 28.9541C41.2156 28.9693 41.1759 28.9771 41.1359 28.9771H35.3506V27.4708H41.1359C41.2166 27.4708 41.2941 27.5026 41.3512 27.5591C41.4083 27.6156 41.4404 27.6922 41.4404 27.7721V28.6753C41.4404 28.7149 41.4326 28.7541 41.4173 28.7907C41.4021 28.8274 41.3797 28.8606 41.3514 28.8887C41.3231 28.9167 41.2895 28.9389 41.2525 28.9541ZM41.351 34.6122C41.2939 34.6685 41.2165 34.7002 41.1359 34.7002H35.3506V33.194H41.1359C41.2166 33.194 41.2941 33.2257 41.3512 33.2822C41.4083 33.3387 41.4404 33.4153 41.4404 33.4952V34.3995C41.4402 34.4793 41.4081 34.5558 41.351 34.6122ZM42.2647 31.7499C42.2076 31.8064 42.1301 31.8381 42.0494 31.8381H35.3506V30.3319H42.0494C42.1301 30.332 42.2074 30.3638 42.2645 30.4203C42.3216 30.4767 42.3537 30.5533 42.3538 30.6331V31.5369C42.3538 31.6168 42.3218 31.6934 42.2647 31.7499ZM33.6725 31.1683C33.6716 30.939 33.6524 30.7101 33.615 30.4838H30.1748V31.8413H32.1448C31.9823 32.6688 31.2477 33.2686 30.1748 33.2686C28.9791 33.2686 28.0112 32.2678 28.0112 31.0847C28.0112 29.9017 28.9812 28.9008 30.1748 28.9008C30.6958 28.8925 31.1993 29.0871 31.5764 29.4428L32.6192 28.4111C31.9576 27.7971 31.0814 27.4603 30.1743 27.4714C29.6908 27.4656 29.211 27.5549 28.7626 27.7339C28.3143 27.913 27.9063 28.1784 27.5623 28.5146C27.2184 28.8508 26.9453 29.2512 26.7589 29.6926C26.5725 30.1341 26.4766 30.6077 26.4766 31.0861C26.4766 31.5644 26.5725 32.038 26.7589 32.4795C26.9453 32.9209 27.2184 33.3213 27.5623 33.6575C27.9063 33.9937 28.3143 34.2591 28.7626 34.4382C29.211 34.6172 29.6908 34.7065 30.1743 34.7007C32.2852 34.7007 33.6725 33.2331 33.6725 31.1683Z",
    fill: "#0DD0BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4969",
    x: -4.44016,
    y: -5.58621,
    width: 77.8276,
    height: 77.8276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.82759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4969",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGreen);
export default __webpack_public_path__ + "static/media/email-green.d8106202cbb7cccc2f4c32baa6acfd7f.svg";
export { ForwardRef as ReactComponent };